export default __webpack_public_path__ + "static/media/Play.8df64ff4.svg";